/**
 * Enum usada dos tipos de visualização que podem ser feitas no mapa.
 * 
 * O valor de cada atributo estático serve como índice para acessar as configurações dessas visualizações
 * em outras classes.
 */
export enum HeatmapType {

    STATIONS = 0,
    HEATMAP = 1,
    HIGHWAYS = 2,
    RIVERS = 3,
    NEIGHBORHOOD = 4,
    VORONOI = 5,
    EVENTS = 6,
    CAMERA = 7,
    EVENTS_HEATMAP = 8,
    COMMUNITIES = 9,
    ALTITUDE = 10,
    DECLIVIDADE = 11,
    CLUSTER2 = 12,
    CLUSTER5 = 13,
    CLUSTER6 = 14,
    CLUSTER7 = 15,
    INCIDENT = 16,
    CONSERVATION = 17,
}
